<template>
  <div class="avis">
    <section>
      <ul class="terms-list">
        <li><a href="#privacy_notice">Avis de confidentialité</a></li>
        <li>
          <a href="#protecting_security"
            >Veiller à la sécurité des sites Web du gouvernement du Canada</a
          >
        </li>
        <li>
          <a href="#outside_files"
            >Emploi de fichiers situés sur des serveurs autres que ceux du
            gouvernement du Canada</a
          >
        </li>
        <li>
          <a href="#official_languages"
            >Offrir un contenu dans les deux langues officielles</a
          >
        </li>
        <li>
          <a href="#website_linking"
            >L'établissement d'hyperliens à des sites Web autres que ceux du
            gouvernement du Canada</a
          >
        </li>
        <li>
          <a href="#ownership_content"
            >Propriété et utilisation du contenu offert dans ce site</a
          >
        </li>
        <li>
          <a href="#trademark_notice">Avis concernant l'image de marque</a>
        </li>
        <li>
          <a href="#accessibility_commitment"
            >Notre engagement à l'égard de l'accessibilité</a
          >
        </li>
        <li><a href="#media_requests">Questions et demandes des médias</a></li>
      </ul>
    </section>
    <section id="privacy_notice">
      <h2 class="subtitle is-size-3">Avis de confidentialité</h2>
      <p>
        Le gouvernement du Canada et PerLE s'engagent à offrir des sites Web qui
        respectent la confidentialité des visiteurs. L'avis de confidentialité
        résume les pratiques de protection des renseignements personnels pour
        les activités en ligne du PerLE.
      </p>
      <br />
      <p>
        Tous les renseignements personnels recueillis par cette institution sont
        gouvernés par la
        <a
          target="_blank"
          rel="noopener"
          href="https://laws-lois.justice.gc.ca/fra/lois/P-21/index.html"
          >Loi sur la protection des renseignements personnels</a
        >. Cela signifie que vous serez avisé de la raison pour laquelle vos
        renseignements personnels sont recueillis et de la façon d'exercer vos
        droits d'accès à l'information.
      </p>
      <br />
      <h3 class="subtitle is-size-4">Votre confidentialité et Internet</h3>
      <p>
        La nature d'Internet est telle que les serveurs recueillent
        automatiquement certaines informations concernant la visite d'un site
        Web, y compris l'adresse du protocole Internet (IP). L'adresse IP
        consiste en une série de numéros unique accordé par les fournisseurs de
        services Internet (FSI) à tous les appareils utilisés pour accéder à
        Internet. Les serveurs Web enregistrent automatiquement les adresses IP
        des visiteurs. Cette adresse, en soit, ne permet pas d'identifier une
        personne. Par contre, dans certaines circonstances, comme avec la
        coopération d'un FSI par exemple, elle peut être utilisée pour
        identifier une personne qui visite ce site. Pour cette raison, le
        gouvernement du Canada juge que l'adresse IP est un renseignement
        personnel, surtout, lorsqu'il est accompagné d'autres données qui sont
        recueillies automatiquement lorsqu'un visiteur demande une page Web,
        comme la page consultée, la date et l'heure de la visite.
      </p>
      <br />
      <p>
        Lorsque les services sont fournis par des organisations de l'extérieur
        du gouvernement du Canada, comme les plateformes de médias sociaux ou
        les applications mobiles, les adresses IP peuvent être enregistrées par
        un serveur Web du tiers fournisseur de services. À moins d'avis
        contraire, PerLE ne recueille pas automatiquement d'information précise
        à votre sujet, tel que votre nom, numéro de téléphone ou adresse de
        courriel. PerLE peut obtenir ce genre d'information uniquement si vous
        la fournissez, par exemple, dans un courriel ou en remplissant un
        formulaire en ligne. Le cas échéant, la façon dont sont traités vos
        renseignements personnels est précisée dans un énoncé de collecte de
        renseignements personnels.
      </p>
      <br />
      <h3 class="subtitle is-size-4">
        Communiquer avec le gouvernement du Canada
      </h3>
      <p>
        Si vous choisissez d'envoyer un courriel au PerLE ou remplissez un
        formulaire de rétroaction en ligne, vos renseignements personnels sont
        utilisés par PerLE pour répondre à votre demande. Les renseignements
        personnels que vous fournissez ne seront partagés avec une autre
        institution gouvernementale que si votre demande porte sur cette
        institution. PerLE n'utilise pas ces renseignements personnels pour
        créer des profils individuels et ne peut pas les divulguer, sauf aux
        autres institutions du gouvernement fédéral qui sont concernées par
        cette demande. Toute divulgation de vos renseignements personnels doit
        se faire en vertu de la
        <a
          target="_blank"
          rel="noopener"
          href="https://laws-lois.justice.gc.ca/fra/lois/P-21/index.html"
          >Loi sur la protection des renseignements personnels</a
        >.
      </p>
      <br />
      <p>
        Les courriels et autres méthodes électroniques utilisées pour
        communiquer avec le gouvernement du Canada ne sont pas sécuritaires, à
        moins qu'il ne soit précisé autrement dans la page Web. Il est donc
        recommandé <strong>de ne pas</strong> transmettre des renseignements
        personnels sensibles, comme votre numéro d'assurance sociale ou votre
        date de naissance, par l'entremise d'une voie électronique non
        sécurisée.
      </p>
      <br />
      <p>
        Les renseignements personnels compris dans des courriels ou des
        formulaires de rétroaction sont recueillis en vertu des dispositions
        pertinentes de la loi habilitante de l'Innovation, Sciences et
        Développement économique Canada. De tels renseignements peuvent être
        utilisés à des fins statistiques, d'évaluation et d'établissement de
        rapports, et sont versés dans le fichier de renseignements personnels
        POU 914 — Communications publiques.
      </p>
      <br />
      <h3 class="subtitle is-size-4">
        Améliorer votre expérience dans les sites Web du gouvernement du Canada
      </h3>
      <h4 class="subtitle">
        Marqueurs numériques (y compris les témoins)
      </h4>
      <p>
        Un marqueur numérique est une ressource créée par le navigateur du
        visiteur afin de retenir certains renseignements auxquels peut faire
        référence le serveur Web dans le cadre de la même visite ou de visites
        subséquentes. Les témoins et les spécifications de stockage Web HTML5
        sont des exemples de marqueurs numériques. Voici quelques exemples de ce
        que font les marqueurs numériques :
      </p>
      <ul class="terms-list">
        <li>
          Ils permettent à un site Web de reconnaître la dernière visite de
          l'utilisateur chaque fois qu'il visite le site.
        </li>
        <li>
          Ils tiennent compte de l'information consultée dans le site afin de
          permettre aux administrateurs à s'assurer d'une recherche plus
          efficace pour les visiteurs.
        </li>
      </ul>
      <p>
        PerLE se sert de marqueurs numériques de session et persistants à
        certains endroits dans son site Web. Pendant votre visite en ligne,
        votre navigateur échange des données avec le serveur Web du PerLE. Les
        marqueurs numériques ne permettent pas à l'institution d'identifier les
        utilisateurs.
      </p>
      <br />
      <p>
        Vous pouvez ajuster les paramètres de votre navigateur de sorte à
        rejeter les marqueurs numériques, y compris les témoins. Toutefois, ceci
        pourrait avoir une incidence sur votre capacité d'interagir avec le site
        Web du PerLE.
      </p>
      <br />
      <h3 class="subtitle is-size-4">Le Web analytique</h3>
      <p>
        Le Web analytique consiste en la collecte, l'analyse, la mesure et la
        présentation de données sur l'achalandage d'un site Internet et sur les
        visites, dans le but de comprendre et d'optimiser l'utilisation du Web.
        Les renseignements recueillis par les marqueurs numériques peuvent être
        utilisés dans le cadre du Web analytique pour garder en mémoire vos
        interactions avec le site Web de l'institution.
      </p>
      <br />
      <p>
        PerLE se sert de Google Analytics pour améliorer son site Web. Lorsque
        votre ordinateur demande d'avoir accès à la page Web du PerLE, notre
        institution recueille les renseignements suivants aux fins du Web
        analytique :
      </p>
      <ul class="terms-list">
        <li>l'adresse IP d'origine;</li>
        <li>la date et l'heure de la demande;</li>
        <li>le type de navigateur utilisé;</li>
        <li>la(les) page(s) visitée(s).</li>
      </ul>
      <p>
        PerLE se sert Google Analytics et les données recueillies sont
        transmises à Google Inc., un fournisseur de services externe. Votre
        adresse IP est dépersonnalisée avant d'être stockée sur le serveur du
        fournisseur de services pour veiller à la protection de vos
        renseignements personnels. Les données recueillies sont dépersonnalisées
        de la façon suivante&nbsp;: activer la fonction d'anonymisation dans
        Google Analytics.
      </p>
      <br />
      <p>
        Les données recueillies aux fins du Web analytique sont transmises aux
        États-Unis et peuvent être assujetties à la loi en vigueur dans ce pays,
        la
        <a
          target="_blank"
          rel="noopener"
          href="https://www.fincen.gov/resources/statutes-and-regulations/usa-patriot-act"
          >Patriot Act des États-Unis</a
        >
        (en anglais seulement).
      </p>
      <br />
      <p>
        Les données utilisées aux fins du Web analytique sont recueillies
        conformément à la disposition pertinente de la loi habilitante de
        l'Innovation, Sciences et Développement économique Canada. De telles
        données peuvent être utilisées pour établir des statistiques sur les
        communications et les technologies d'information, ainsi qu'à des fins
        d'évaluation, de recherche, de planification et d'établissement de
        rapports. Pour obtenir de plus amples renseignements sur la façon dont
        vos renseignements personnels sont protégés dans le cadre du Web
        analytique, veuillez consulter la
        <a
          target="_blank"
          rel="noopener"
          href="https://www.tbs-sct.gc.ca/pol/doc-fra.aspx?id=26761"
          >Norme sur la protection de la vie privée et le Web analytique</a
        >.
      </p>
      <br />
    </section>
    <section id="protecting_security">
      <h2 class="subtitle is-size-3">
        Veiller à la sécurité des sites Web du gouvernement du Canada
      </h2>
      <p>
        PerLE utilise des logiciels pour suivre l'achalandage du réseau et pour
        repérer les essais non autorisés de téléchargement ou de modification de
        renseignements ou encore les tentatives d'accès visant à causer des
        dommages. Le logiciel reçoit et enregistre l'adresse IP de l'ordinateur
        qui a communiqué avec notre site Web, la date et l'heure de la visite et
        les pages consultées. Nous ne tentons pas d'établir de lien entre ces
        adresses et l'identité des utilisateurs qui consultent notre site Web à
        moins d'avoir détecté une tentative de dommage à notre site.
      </p>
      <br />
      <p>
        Ces données sont recueillies conformément à l'
        <a
          target="_blank"
          rel="noopener"
          href="http://laws-lois.justice.gc.ca/fra/lois/f-11/"
          >article 161 de la Loi sur la gestion des finances publiques</a
        >. Ces renseignements peuvent être communiqués aux organismes chargés de
        l'application de la loi que si l'on soupçonne des activités criminelles
        possibles. De tels renseignements peuvent être utilisés pour établir des
        statistiques sur la sécurité du réseau, ainsi qu'à des fins de
        vérification, d'évaluation, de recherche, de planification et
        d'établissement de rapports, et figurent dans le fichier de
        renseignements personnels POU 914 — Communications publiques.
      </p>
      <br />
      <h3 class="subtitle is-size-4">
        Demandes relatives à la protection des renseignements personnels
      </h3>
      <p>
        Si vous avez des questions, des commentaires, des préoccupations ou des
        plaintes concernant l'administration de la
        <a
          target="_blank"
          rel="noopener"
          href="https://laws-lois.justice.gc.ca/fra/lois/P-21/index.html"
          >Loi sur la protection des renseignements personnels</a
        >
        ou sur les politiques de protection de la vie privée relatives à la
        présence Web du PerLE, vous pouvez communiquer avec notre coordonnateur
        de l'accès à l'information et de la protection des renseignements
        personnels par courriel, par téléphone ou par écrit. Voici nos
        coordonnées :
      </p>
      <p class="address">
        Services de l'accès à l'information et de la protection des
        renseignements personnels (AIPRP)<br />
        Innovation, Sciences et Développement économique Canada<br />
        Édifice C.D.-Howe<br />
        2e étage, tour Ouest<br />
        235, rue Queen<br />
        Ottawa (Ontario) K1A 0H5<br />
        <br />
        Téléphone : 343-291-2792<br />
        Télécopieur : 343-291-1893<br />
        Courriel :
        <a href="mailto:ic.atip-aiprpa.ic@canada.ca"
          >ic.atip-aiprpa.ic@canada.ca</a
        ><br />
      </p>
      <p>
        Si vous n'êtes pas satisfaits de la réponse d'Innovation, Sciences et
        Développement économique Canada à votre préoccupation concernant la
        protection de vos renseignements personnels, vous pouvez communiquer
        avec le
        <a
          target="_blank"
          rel="noopener"
          href="http://www.priv.gc.ca/index_f.asp"
          >Commissariat à la protection de la vie privée du Canada</a
        >
        par courriel, à l'adresse
        <a href="mailto:info@priv.gc.ca">info@priv.gc.ca</a> ou par téléphone,
        au 1‑800‑282‑1376.
      </p>
      <br />
    </section>
    <section id="outside_files">
      <h2 class="subtitle is-size-3">
        Emploi de fichiers situés sur des serveurs autres que ceux du
        gouvernement du Canada
      </h2>
      <p>
        Afin d'améliorer la fonctionnalité des sites Web du gouvernement du
        Canada, certains fichiers (tels que les bibliothèques à code source
        ouvert, les images et les scripts) peuvent être téléchargés
        automatiquement vers votre navigateur par l'entremise d'un serveur tiers
        ou d'un réseau de diffusion de contenu de confiance. La diffusion de ces
        fichiers vise à offrir une expérience utilisateur transparente en
        diminuant les temps de réponse et en évitant le téléchargement de ces
        fichiers par chaque visiteur. Le cas échéant, des énoncés de protection
        des renseignements personnels traitant spécifiquement de ces fichiers se
        trouvent dans notre Avis de confidentialité.
      </p>
      <br />
    </section>
    <section id="official_languages">
      <h2 class="subtitle is-size-3">
        Offrir un contenu dans les deux langues officielles
      </h2>
      <p>
        La
        <a
          target="_blank"
          rel="noopener"
          href="http://laws-lois.justice.gc.ca/fra/lois/O-3.01/"
          >Loi sur les langues officielles</a
        >, le
        <a
          target="_blank"
          rel="noopener"
          href="http://laws-lois.justice.gc.ca/fra/reglements/DORS-92-48/index.html"
          >Règlement sur les langues officielles – communications avec le public
          et prestation des services</a
        >
        et les exigences stratégiques du Conseil du Trésor sont de rigueur
        lorsque PerLE emploie le français et l'anglais dans la prestation de
        services ou de communications avec le public. S'il n'y a pas
        d'obligation d'offrir le contenu dans les deux langues officielles,
        celui-ci pourrait être offert uniquement dans une des langues
        officielles. L'information offerte par des entités non assujetties à la
        <a
          target="_blank"
          rel="noopener"
          href="http://laws-lois.justice.gc.ca/fra/lois/O-3.01/"
          >Loi sur les langues officielles</a
        >
        n'est diffusée que dans la langue dans laquelle fournie. Toute
        information dans une langue autre que l'anglais ou le français n'est
        offerte que par commodité aux visiteurs de notre site Web.
      </p>
      <br />
    </section>
    <section id="website_linking">
      <h2 class="subtitle is-size-3">
        L'établissement d'hyperliens vers des sites Web autres que ceux du
        gouvernement du Canada
      </h2>
      <p>
        Les hyperliens menant à des sites Web qui ne sont pas gérés par le
        gouvernement du Canada ne sont offerts que par commodité aux visiteurs
        de notre site Web. Nous n'assumons aucune responsabilité quant à la
        précision, l'actualité ou la fiabilité du contenu de ces sites. Le
        gouvernement du Canada n'offre aucune garantie à cet égard, n'assume
        aucune responsabilité concernant l'information diffusée par ces liens et
        n'approuve pas ces sites ou leur contenu.
      </p>
      <br />
      <p>
        Il est également important pour les visiteurs de noter que toute
        information offerte par les sites autres que ceux du gouvernement du
        Canada, accessibles à l'aide des liens de ce site Web, n'est assujettie
        ni à la
        <a
          target="_blank"
          rel="noopener"
          href="https://laws-lois.justice.gc.ca/fra/lois/P-21/index.html"
          >Loi sur la protection des renseignements personnels</a
        >
        ni à la
        <a
          target="_blank"
          rel="noopener"
          href="http://laws-lois.justice.gc.ca/fra/lois/O-3.01/"
          >Loi sur les langues officielles</a
        >, et pourrait ne pas être accessible aux personnes handicapées. Il se
        pourrait que l'information offerte ne soit disponible que dans les
        langues employées dans les sites en question. En ce qui a trait aux
        renseignements personnels, on invite les visiteurs à consulter les
        politiques de protection des renseignements personnels de ces sites qui
        ne relèvent pas du gouvernement du Canada avant de fournir leurs
        renseignements personnels.
      </p>
      <br />
    </section>
    <section id="ownership_content">
      <h2 class="subtitle is-size-3">
        Propriété et utilisation du contenu offert dans ce site
      </h2>
      <p>
        Le contenu de ce site Web a été produit ou rassemblé par PerLE afin
        d'offrir aux Canadiens l'accès aux renseignements concernant les
        licenses et permis offerts par le gouvernement du Canada, Gouvernements
        provinciaux/territoriaux et municipaux. Vous pouvez utiliser et
        reproduire le contenu des façons suivantes :
      </p>
      <br />
      <h3 class="subtitle is-size-4">Reproduction non commerciale</h3>
      <p>
        À moins d'avis contraire, vous pouvez reproduire le contenu en totalité
        ou en partie à des fins non commerciales, dans un format quelconque,
        sans frais ni autre permission, à condition :
      </p>
      <ul class="terms-list">
        <li>
          de faire preuve de diligence raisonnable quant à la précision du
          contenu reproduit;
        </li>
        <li>
          de préciser le titre complet du contenu reproduit, ainsi que l'auteur
          (s'il y a lieu);
        </li>
        <li>
          de préciser qu'il s'agit d'une reproduction de la version disponible à
          l'adresse <em>[URL où le document original se trouve]</em>.
        </li>
      </ul>
      <h3 class="subtitle is-size-4">Reproduction commerciale</h3>
      <p>
        À moins d'avis contraire, il est interdit de reproduire le contenu de ce
        site, en totalité ou en partie, à des fins de diffusion commerciale sans
        avoir obtenu au préalable la permission écrite d'Innovation, Sciences et
        Développement économique Canada.
      </p>
      <br />
      <p>
        Si vous souhaitez obtenir les droits de reproduction du contenu du
        gouvernement du Canada du présent site à des fins commerciales, veuillez
        <a
          target="_blank"
          rel="noopener"
          href="http://www.ic.gc.ca/eic/site/icgc.nsf/fra/07413.html"
          >demander l'affranchissement du droit d'auteur de la Couronne</a
        >
        ou écrire à la :
      </p>
      <p class="address">
        Centre de services aux citoyens d'ISDE<br />
        Innovation, Sciences et Développement économique Canada<br />
        4e étage, tour Est<br />
        235, rue Queen<br />
        Ottawa (Ontario) K1A 0H5<br />
        Canada<br />
        <br />
        Courriel :
        <a href="mailto:ISDE@canada.ca">ISDE@canada.ca</a>
        <br />
      </p>
      <p>
        Vous pouvez aussi nous contacter pour obtenir de plus amples
        renseignements sur la propriété et les restrictions en matière de droit
        d'auteur, puisqu'une partie du contenu de ce site pourrait être
        assujettie au droit d'auteur d'une tierce partie. Lorsque des
        informations sont produites ou si le gouvernement du Canada n'est pas le
        détenteur du droit d'auteur, le contenu est protégé par la
        <a
          target="_blank"
          rel="noopener"
          href="http://laws-lois.justice.gc.ca/fra/lois/C-42/index.html"
          >Loi sur le droit d'auteur</a
        >
        et des ententes internationales. Les détails relatifs au droit d'auteur
        sont précisés sur les pages pertinentes.
      </p>
      <br />
    </section>
    <section id="trademark_notice">
      <h2 class="subtitle is-size-3">Avis concernant l'image de marque</h2>
      <p>
        La reproduction des symboles officiels du gouvernement du Canada, y
        compris le mot-symbole « Canada », les armoiries du Canada et le symbole
        du drapeau et ceux des autres provinces et territoires, à des fins
        commerciales ou non commerciales, est interdite sans
        <a
          target="_blank"
          rel="noopener"
          href="http://www.tbs-sct.gc.ca/hgw-cgf/oversight-surveillance/communications/fip-pcim/spec/100/T105-fra.asp"
          >autorisation écrite</a
        >
        au préalable.
      </p>
      <br />
      <h3 class="subtitle is-size-4">Droit d'auteur</h3>
      <p>
        L'information que nous publions est assujettie à la
        <a
          target="_blank"
          rel="noopener"
          href="http://laws-lois.justice.gc.ca/fra/lois/C-42/index.html"
          >Loi sur le droit d'auteur</a
        >.
      </p>
      <br />
    </section>
    <section id="accessibility_commitment">
      <h2 class="subtitle is-size-3">
        Notre engagement à l'égard de l'accessibilité
      </h2>
      <p>
        Le gouvernement du Canada est déterminé à maintenir une norme
        d'accessibilité élevée conformément à la
        <a
          target="_blank"
          rel="noopener"
          href="http://www.tbs-sct.gc.ca/pol/doc-fra.aspx?id=23601"
          >Norme sur l'accessibilité des sites Web</a
        >. Veuillez communiquer avec nous si vous éprouvez des difficultés à
        utiliser nos pages Web, applications ou applications pour appareils
        mobiles, ou si vous désirez obtenir des formats de substitution comme
        une version imprimée, une version en braille ou tout autre format
        pertinent.
      </p>
      <br />
    </section>
    <section id="media_requests">
      <h2 class="subtitle is-size-3">Questions et demandes des médias</h2>
      <p>
        Nous demandons aux journalistes d'envoyer leurs questions à :
      </p>
      <p class="address">
        Téléphone : 343-291-1777<br />
        Courriel :
        <a href="mailto:ic.mediarelations-mediasrelations.ic@canada.ca"
          >ic.mediarelations-mediasrelations.ic@canada.ca</a
        ><br />
        Heures de bureau : 7 h 30 à 18 h (heure de l'Est)<br />
      </p>
    </section>
    <section>
      <h2 class="subtitle is-size-3">Exonération de responsabilité</h2>
      <p>
        Les renseignements contenus dans le site du PerLE proviennent de
        nombreux ministères et organismes fédéraux, de sources extérieures,
        ainsi que d'autres paliers de gouvernement. Nous avons déployé tous les
        efforts nécessaires pour assurer l'exactitude, l'actualité et la
        fiabilité du contenu. Les utilisateurs qui souhaitent se servir de ces
        renseignements ou se prévaloir de ces services peuvent consulter
        directement le centre PerLE de leur province ou territoire.
      </p>
    </section>
  </div>
</template>

<script>
export default {
  name: "Avis"
};
</script>

<style></style>
